import { apiGet, apiPut } from './index'

export interface StationResponse {
  id: number
  name: string
  timezone: string
}

export async function getStation(stationId: number): Promise<StationResponse> {
  return apiGet<StationResponse>(`stations/${stationId}`)
}

export async function updateStation(
  stationId: number,
  payload: { timezone: string },
): Promise<StationResponse> {
  return apiPut<StationResponse>(`stations/${stationId}`, payload)
}
